// NdrDownloadModal.tsx
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { DownloadIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Select } from './ui/Select';
import { useNdr } from '../hooks/useNdr';

interface CourierOption {
  id: string;
  name: string;
}

interface NdrDownloadModalProps {
  onClose?: () => void;
  couriers?: CourierOption[];
  fromDate?: string;
}

export const NdrDownloadModal: React.FC<NdrDownloadModalProps> = ({ onClose, couriers = [], fromDate }) => {
  const [selectedCourier, setSelectedCourier] = useState<string>('');
  const { downloadNdr, loading } = useNdr();

  const handleDownload = async () => {
    if (!selectedCourier) {
      toast.error('Please select a courier partner first!');
      return;
    }
    
    try {
      await downloadNdr(selectedCourier, fromDate);
      toast.success('Downloading NDR Report..');
      if (onClose) onClose();
    } catch (err: any) {
      console.error(err);
    }
  };

 return (
    <div className="p-6">
      <div className="text-center mb-6">
        <h2 className="text-xl font-bold text-gray-900 mb-2">Courier Partner</h2>
        <p className="text-gray-600 text-sm">Select a courier partner to download NDR data</p>
      </div>

      <div className="mb-8">
        <Select
          value={selectedCourier}
          onChange={(e) => setSelectedCourier(e.target.value)}
          placeholder="Select Courier Partner"
          options={[
            { label: 'All Couriers', value: '0' },
            ...couriers.map((courier) => ({
              label: courier.name,
              value: courier.id,
            }))
          ]}
        />
        
        {selectedCourier && (
          <div className="mt-4 p-3 bg-accent/5 rounded-lg border border-accent/20">
            <p className="text-sm text-gray-700">
              Selected: <span className="font-semibold">
                {selectedCourier === 'all' ? 'All Couriers' : couriers.find(c => c.id === selectedCourier)?.name}
              </span>
            </p>
          </div>
        )}
      </div>

      <Button
        onClick={handleDownload}
        disabled={loading || !selectedCourier}
    className="w-full py-3 flex items-center justify-center gap-2 disable-if-loading"
      >
        <DownloadIcon size={20} />
        {loading ? 'Downloading...' : 'Download'}
      </Button>
    </div>
  );
};

export default NdrDownloadModal;